import { createSelector } from 'reselect';
import { getProductImageData } from '../helpers.js';
import { frameSkuProp } from '../selectors.internal.js';
import { getFrame } from './selectors.internal.js';

const frameImageProps = (_, props)=>props
;
const getFrameImage = createSelector(getFrame, frameSkuProp, frameImageProps, (frame, frameSku, frameImageProps1)=>{
    if (!frame) {
        return undefined;
    }
    const { width  } = frameImageProps1;
    return getProductImageData(frame, frameSku, width);
});

export { frameImageProps, getFrameImage };
//# sourceMappingURL=selectors.js.map
